import type { CodeMigration } from './types.js';

/**
 * Migration for v2.0.0-preview.381
 * Adds SmartStackProvider to App.tsx if missing
 */
export const appTsxMigration_v2_0_0_preview_381: CodeMigration = {
  axis: 'socle',
  fromVersion: '2.0.0-preview.380',
  toVersion: '2.0.0-preview.381',
  description: 'Add SmartStackProvider to App.tsx for proper context initialization',

  migrations: [
    {
      pattern: '**/App.tsx',
      description: 'Wrap routes with SmartStackProvider',

      detect: (content: string): boolean => {
        // Migration needed if:
        // 1. File imports from @atlashub/smartstack
        // 2. BUT does NOT use SmartStackProvider
        const hasSmartStackImport = content.includes('@atlashub/smartstack');
        const hasSmartStackProvider = content.includes('SmartStackProvider');

        return hasSmartStackImport && !hasSmartStackProvider;
      },

      transform: (content: string): string => {
        // BrowserRouter and SmartStackProvider should be in main.tsx, not App.tsx
        // App.tsx should only return useRoutes(routes)
        return content;
      }
    }
  ]
};
